import * as React from 'react';

const defaultClassName = ['inline-block', 'align-middle'].join(' ');

export default ({ className = '' }: { className?: string }) => {
  const classNames = [defaultClassName, className].join(' ');
  return (
    <svg
      className={classNames}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      data-testid="close-icon"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke="currentColor"
        strokeWidth="strokeCurrent"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
